<template>
  <div class="modale-background" @click="$emit('dismiss')">
    <div class="modale" @click.stop>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.modale-background {
  z-index: 998;
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modale {
  border-radius: 15px;
  background-color: rgb(255, 255, 255);
  box-shadow: inset 0 0 35px 5px rgba(0, 0, 0, 0.25),
    inset 0 2px 1px 1px rgba(255, 255, 255, 0.5),
    inset 0 -2px 1px 0 rgba(46, 15, 15, 0.25);
  padding: 15px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/Modale.vue